/* global window */

import { Component } from 'react';

class Scroll extends Component {
  componentWillMount() {
    window.addEventListener('scroll', () => {
      this.props.onChange({ y: window.scrollY, x: window.scrollX });
    });
  }

  render() {
    return null;
  }
}

export default Scroll;



// WEBPACK FOOTER //
// ./src/components/Scroll/index.js